export default __webpack_public_path__ + "static/media/moly.be632530.svg";